import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { 
  Heart, 
  Activity, 
  Users, 
  Target, 
  Clock, 
  CheckCircle,
  ArrowRight,
  Stethoscope,
  Dumbbell,
  Baby,
  Zap,
  Phone,
  Calendar,
  Flower2,
  Hand,
  Waves,
  Sparkles,
  Compass,
  RotateCcw
} from 'lucide-react';

const Servizi = () => {
  const serviziDettagliati = [
    {
      title: "Fisioterapia",
      subtitle: "Trattamenti Terapeutici Specializzati",
      description: "Terapie manuali e strumentali per il recupero funzionale completo",
      icon: Heart,
      image: "/images/fisioterapia_centro_1.jpeg",
      durata: "45-60 min",
      prezzo: "€ 50",
      dettagli: [
        "Valutazione funzionale completa",
        "Terapia manuale osteopatica",
        "Mobilizzazioni articolari",
        "Tecniche di rilassamento muscolare",
        "Trattamento del dolore acuto e cronico"
      ]
    },
    {
      title: "Riabilitazione Motoria",
      subtitle: "Recupero Funzionale Personalizzato",
      description: "Programmi specifici per il recupero della mobilità e della forza",
      icon: Activity,
      image: "/images/fisioterapia_centro_2.webp",
      durata: "60 min",
      prezzo: "€ 60",
      dettagli: [
        "Rieducazione motoria post-traumatica",
        "Recupero post-chirurgico",
        "Rinforzo muscolare progressivo",
        "Rieducazione propriocettiva",
        "Training funzionale specifico"
      ]
    },
    {
      title: "Ginnastica Posturale",
      subtitle: "Correzione e Prevenzione",
      description: "Correzione dei difetti posturali e prevenzione dei disturbi",
      icon: Target,
      image: "/images/terapia_esercizi_1.jpeg",
      durata: "50 min",
      prezzo: "€ 45",
      dettagli: [
        "Analisi posturale computerizzata",
        "Esercizi di correzione posturale",
        "Stretching miofasciale",
        "Educazione posturale",
        "Prevenzione mal di schiena"
      ]
    },
    {
      title: "Specialista Età Evolutiva",
      subtitle: "Trattamenti Pediatrici",
      description: "Terapie dedicate ai bambini e adolescenti per una crescita sana",
      icon: Users,
      image: "/images/ginnastica_posturale_1.jpeg",
      durata: "40 min",
      prezzo: "€ 55",
      dettagli: [
        "Valutazione dello sviluppo motorio",
        "Trattamento scoliosi pediatrica",
        "Ginnastica correttiva per bambini",
        "Educazione motoria",
        "Supporto ai genitori"
      ]
    },
    {
      title: "Terapia Manuale",
      subtitle: "Tecniche Manuali Avanzate",
      description: "Trattamenti manuali specializzati per problematiche specifiche",
      icon: Stethoscope,
      image: "/images/studio_professionale_1.jpeg",
      durata: "45 min",
      prezzo: "€ 55",
      dettagli: [
        "Manipolazioni vertebrali",
        "Mobilizzazioni articolari",
        "Massoterapia terapeutica",
        "Trigger point therapy",
        "Tecniche miofasciali"
      ]
    },
    {
      title: "Rieducazione Funzionale",
      subtitle: "Ritorno alle Attività",
      description: "Programmi per il ritorno alle attività quotidiane e sportive",
      icon: Dumbbell,
      image: "/images/terapia_esercizi_3.jpeg",
      durata: "60 min",
      prezzo: "€ 65",
      dettagli: [
        "Valutazione funzionale specifica",
        "Esercizi sport-specifici",
        "Prevenzione infortuni",
        "Conditioning fisico",
        "Return to sport protocol"
      ]
    },
    {
      title: "Fitness e Potenziamento Muscolare",
      subtitle: "Trainer Dedicato e Personalizzazione",
      description: "Allenamento personalizzato con trainer qualificato per il potenziamento muscolare",
      icon: Dumbbell,
      image: "/images/fitness_training_2.jpeg",
      durata: "60 min",
      prezzo: "€ 50-70",
      dettagli: [
        "Personal trainer dedicato",
        "Programmi di potenziamento personalizzati",
        "Allenamento funzionale",
        "Conditioning atletico",
        "Monitoraggio progressi",
        "Prevenzione infortuni sportivi"
      ]
    },
    {
      title: "Riprogrammazione Muscolare",
      subtitle: "Rieducazione Neuromuscolare Avanzata",
      description: "Tecniche specializzate per la riprogrammazione dei pattern motori",
      icon: Activity,
      image: "/images/riprogrammazione_muscolare_1.jpeg",
      durata: "45-60 min",
      prezzo: "€ 60-80",
      dettagli: [
        "Analisi del movimento",
        "Rieducazione propriocettiva",
        "Correzione pattern motori",
        "Esercizi neuromotori specifici",
        "Biofeedback muscolare",
        "Integrazione sensomotoria"
      ]
    },
    {
      title: "Massaggio Sportivo e Miofasciale",
      subtitle: "Trattamenti Decontratturanti Specializzati",
      description: "Massaggi terapeutici per sportivi e trattamenti miofasciali",
      icon: Stethoscope,
      image: "/images/massaggio_sportivo_1.jpeg",
      durata: "30-45 min",
      prezzo: "€ 40-60",
      dettagli: [
        "Massaggio sportivo pre e post gara",
        "Trattamento decontratturante",
        "Rilascio miofasciale",
        "Drenaggio linfatico",
        "Trattamento trigger points",
        "Recupero muscolare accelerato"
      ]
    },
    {
      title: "Analisi Posturale Digitale APECS",
      subtitle: "Valutazione Posturale con Fotogrammetria",
      description: "Analisi posturale avanzata attraverso fotogrammetria digitale per valutazione rapida e precisa",
      icon: Activity,
      image: "/images/analisi_posturale_digitale_2.webp",
      durata: "30-45 min",
      prezzo: "€ 80-100",
      dettagli: [
        "Metodo APECS certificato",
        "Fotogrammetria digitale avanzata",
        "Analisi posturale completa",
        "Report dettagliato con immagini",
        "Valutazione obiettiva e ripetibile",
        "Monitoraggio progressi nel tempo"
      ]
    },
    {
      title: "Screening Scoliosi e Dorso Curvo ISICO",
      subtitle: "Valutazione Specializzata della Colonna",
      description: "Screening professionale per scoliosi e dorso curvo secondo protocolli ISICO",
      icon: Stethoscope,
      image: "/images/screening_scoliosi_1.jpeg",
      durata: "45-60 min",
      prezzo: "€ 90-120",
      dettagli: [
        "Protocolli ISICO certificati",
        "Valutazione scoliosi evolutiva",
        "Screening dorso curvo",
        "Analisi delle curve vertebrali",
        "Consigli terapeutici personalizzati",
        "Follow-up periodico"
      ]
    },
    {
      title: "Programmi Allenamento Digitali",
      subtitle: "Software e App Personalizzate",
      description: "Programmi di allenamento personalizzati con software Trainer Program 3.0 e Training Program Pro",
      icon: Activity,
      image: "/images/software_allenamento_1.png",
      durata: "Variabile",
      prezzo: "€ 60-80",
      dettagli: [
        "Trainer Program 3.0 professionale",
        "Training Program Pro avanzato",
        "App dedicate personalizzate",
        "Monitoraggio progressi digitale",
        "Programmi adattivi",
        "Supporto tecnologico continuo"
      ]
    },
    {
      title: "Laser Terapia BTL",
      subtitle: "Terapia Laser ad Alta Potenza",
      description: "Trattamenti con laser terapeutico BTL per riduzione del dolore e accelerazione della guarigione",
      icon: Activity,
      image: "/images/laser_terapia_1.jpeg",
      durata: "15-30 min",
      prezzo: "€ 25-40",
      dettagli: [
        "Apparecchiature BTL professionali",
        "Laser ad alta potenza",
        "Effetto antinfiammatorio",
        "Stimolazione riparazione tessuti",
        "Riduzione del dolore",
        "Trattamento non invasivo"
      ]
    },
    {
      title: "Ultrasuoni Tradizionali e Cristalli",
      subtitle: "Terapia ad Ultrasuoni Avanzata",
      description: "Trattamenti con ultrasuoni tradizionali e tecnologia a cristalli per terapie profonde",
      icon: Stethoscope,
      image: "/images/apparecchiature_btl_2.jpeg",
      durata: "20-30 min",
      prezzo: "€ 20-35",
      dettagli: [
        "Ultrasuoni tradizionali BTL",
        "Tecnologia a cristalli",
        "Penetrazione profonda",
        "Effetto termico controllato",
        "Riduzione contratture",
        "Miglioramento circolazione"
      ]
    },
    {
      title: "TENS e EMS",
      subtitle: "Elettrostimolazione Terapeutica",
      description: "Trattamenti di elettrostimolazione per controllo del dolore e rinforzo muscolare",
      icon: Activity,
      image: "/images/apparecchiature_btl_1.jpeg",
      durata: "20-40 min",
      prezzo: "€ 20-30",
      dettagli: [
        "TENS per controllo dolore",
        "EMS per rinforzo muscolare",
        "Apparecchiature BTL certificate",
        "Programmi personalizzabili",
        "Trattamento sicuro",
        "Effetto analgesico immediato"
      ]
    },
    {
      title: "Tecar Terapia",
      subtitle: "Diatermia a Radiofrequenza",
      description: "Trattamenti di diatermia per rigenerazione tissutale e riduzione dell'infiammazione",
      icon: Stethoscope,
      image: "/images/tecar_terapia_1.png",
      durata: "30-45 min",
      prezzo: "€ 40-60",
      dettagli: [
        "Diatermia a radiofrequenza",
        "Rigenerazione tissutale",
        "Riduzione edemi",
        "Miglioramento vascolarizzazione",
        "Trattamento capacitivo e resistivo",
        "Recupero accelerato"
      ]
    },
    {
      title: "Magnetoterapia",
      subtitle: "Campi Magnetici Terapeutici",
      description: "Trattamenti con campi magnetici per stimolare la rigenerazione ossea e tissutale",
      icon: Activity,
      image: "/images/apparecchiature_btl_2.jpeg",
      durata: "30-60 min",
      prezzo: "€ 25-40",
      dettagli: [
        "Campi magnetici pulsati",
        "Stimolazione osteogenesi",
        "Rigenerazione tissutale",
        "Riduzione infiammazione",
        "Trattamento fratture",
        "Miglioramento microcircolo"
      ]
    },
    {
      title: "Onde d'Urto BTL",
      subtitle: "Terapia ad Onde d'Urto Focali",
      description: "Trattamenti con onde d'urto per patologie muscolo-scheletriche e calcificazioni",
      icon: Target,
      image: "/images/onde_urto_1.png",
      durata: "15-25 min",
      prezzo: "€ 50-80",
      dettagli: [
        "Onde d'urto focali BTL",
        "Trattamento calcificazioni",
        "Stimolazione angiogenesi",
        "Riduzione dolore cronico",
        "Rigenerazione tessuti",
        "Protocolli evidence-based"
      ]
    },
    {
      title: "Trattamento Plagiocefalie",
      subtitle: "Deformità Craniche Posizionali",
      description: "Trattamento specializzato per plagiocefalie e brachicefalie attraverso terapia manuale e posizionamento",
      icon: Activity,
      image: "/images/plagiocefalia_trattamento_1.jpeg",
      durata: "45-60 min",
      prezzo: "€ 60-80",
      dettagli: [
        "Valutazione morfologica cranio",
        "Terapia manuale specifica",
        "Tecniche di posizionamento",
        "Educazione genitoriale",
        "Monitoraggio evolutivo",
        "Prevenzione peggioramenti"
      ]
    },
    {
      title: "Torcicollo Miogeno Congenito",
      subtitle: "Trattamento Specializzato TNPEE",
      description: "Terapia per torcicollo miogeno congenito con tecniche manuali e esercizi specifici",
      icon: Target,
      image: "/images/terapia_neonatale_1.jpeg",
      durata: "45-60 min",
      prezzo: "€ 60-80",
      dettagli: [
        "Valutazione muscolo sternocleidomastoideo",
        "Stretching muscolare specifico",
        "Mobilizzazione cervicale dolce",
        "Esercizi di rinforzo",
        "Educazione posturale genitori",
        "Follow-up periodico"
      ]
    },
    {
      title: "Paralisi Ostetriche",
      subtitle: "Lesioni Plesso Brachiale",
      description: "Riabilitazione specializzata per paralisi ostetriche e lesioni del plesso brachiale neonatale",
      icon: Stethoscope,
      image: "/images/terapia_neonatale_2.jpeg",
      durata: "60-90 min",
      prezzo: "€ 80-100",
      dettagli: [
        "Valutazione neurologica specifica",
        "Mobilizzazione passiva articolare",
        "Stimolazione neuromuscolare",
        "Tecniche di facilitazione",
        "Training genitoriale",
        "Monitoraggio recupero funzionale"
      ]
    },
    {
      title: "Disturbi Motori Neonatali",
      subtitle: "Valutazione e Trattamento Precoce",
      description: "Intervento precoce per disturbi dello sviluppo motorio, ritardi psicomotori e alterazioni del tono",
      icon: Activity,
      image: "/images/terapia_neonatale_1.jpeg",
      durata: "60 min",
      prezzo: "€ 70-90",
      dettagli: [
        "Valutazione sviluppo psicomotorio",
        "Analisi del tono muscolare",
        "Stimolazione senso-motoria",
        "Facilitazione milestone motori",
        "Counseling genitoriale",
        "Programmi domiciliari"
      ]
    },
    {
      title: "Massaggi Rilassanti",
      subtitle: "Tecniche di Rilassamento e Benessere",
      description: "Massaggi terapeutici per il rilassamento muscolare e il benessere psico-fisico",
      icon: Flower2,
      image: "/images/massaggio_rilassante_1.jpeg",
      durata: "45-60 min",
      prezzo: "€ 40-60",
      dettagli: [
        "Massaggio con tecnica Pompage",
        "Rilassamento muscolare profondo",
        "Riduzione tensioni e stress",
        "Miglioramento circolazione",
        "Tecniche di decontrazione",
        "Ambiente rilassante e musicoterapia"
      ]
    },
    {
      title: "Riflessologia Plantare",
      subtitle: "Terapia Riflessa dei Piedi",
      description: "Pressione su punti specifici dei piedi che corrispondono a organi e zone del corpo",
      icon: Hand,
      image: "/images/riflessologia_plantare_1.png",
      durata: "45 min",
      prezzo: "€ 45",
      dettagli: [
        "Mappatura punti riflessi plantari",
        "Stimolazione zone corrispondenti",
        "Riequilibrio energetico corporeo",
        "Miglioramento funzioni organiche",
        "Riduzione stress e tensioni",
        "Effetto detossificante naturale"
      ]
    },
    {
      title: "Massaggio Antistress",
      subtitle: "Tecniche Mirate per il Benessere",
      description: "Tecniche mirate con deflessioni e stretching per alleviare stress fisico ed emotivo",
      icon: Waves,
      image: "/images/massaggio_rilassante_2.jpeg",
      durata: "50 min",
      prezzo: "€ 50",
      dettagli: [
        "Tecniche di deflessione muscolare",
        "Stretching assistito personalizzato",
        "Rilascio tensioni emotive",
        "Respirazione guidata",
        "Riduzione cortisolo e stress",
        "Riequilibrio sistema nervoso"
      ]
    },
    {
      title: "Massaggio Svedese",
      subtitle: "Tecnica Classica Europea",
      description: "Utilizza manovre di sfioramento, impastamento, frizione, percussione e vibrazione per rilassamento muscolare generale",
      icon: Sparkles,
      image: "/images/massaggio_svedese_1.webp",
      durata: "60 min",
      prezzo: "€ 55",
      dettagli: [
        "Sfioramento (Effleurage)",
        "Impastamento (Petrissage)",
        "Frizione circolare profonda",
        "Percussioni tonificanti",
        "Vibrazioni rilassanti",
        "Rilassamento muscolare completo"
      ]
    },
    {
      title: "Trattamento Scoliosi SEAS",
      subtitle: "Metodo ISICO Specifico",
      description: "Specific Exercises Approach to Scoliosis dell'ISICO, focalizzato sull'auto-correzione attiva",
      icon: Compass,
      image: "/images/trattamento_scoliosi_1.jpeg",
      durata: "60 min",
      prezzo: "€ 65",
      dettagli: [
        "Valutazione posturale 3D",
        "Esercizi auto-correzione attiva",
        "Stabilizzazione colonna vertebrale",
        "Controllo progressione curva",
        "Educazione posturale specifica",
        "Monitoraggio radiografico"
      ]
    },
    {
      title: "Metodo Schroth per Scoliosi",
      subtitle: "Terapia Respiratoria Posturale",
      description: "Metodo basato su esercizi respiratori e posturali specifici per la correzione tridimensionale della scoliosi",
      icon: RotateCcw,
      image: "/images/correzione_spinale_1.jpeg",
      durata: "60 min",
      prezzo: "€ 70",
      dettagli: [
        "Respirazione rotatoria angolare",
        "Correzione tridimensionale",
        "Allungamento derotativo",
        "Stabilizzazione muscolare",
        "Educazione respiratoria",
        "Esercizi domiciliari personalizzati"
      ]
    },
    {
      title: "Valutazione Scoliosi Specialistica",
      subtitle: "Diagnosi e Pianificazione Terapeutica",
      description: "Valutazione completa e trattamento mirato individuale per ogni tipologia di scoliosi",
      icon: Target,
      image: "/images/esercizi_posturali_1.jpeg",
      durata: "90 min",
      prezzo: "€ 80",
      dettagli: [
        "Anamnesi dettagliata familiare",
        "Esame posturale completo",
        "Misurazione angoli Cobb",
        "Classificazione tipologia curva",
        "Piano terapeutico personalizzato",
        "Indicazioni corsetto se necessario"
      ]
    }
  ];

  const patologie = [
    "Mal di schiena e cervicalgia",
    "Ernie discali",
    "Scoliosi e cifosi",
    "Artrosi e artrite",
    "Lesioni sportive",
    "Distorsioni e contusioni",
    "Tendiniti e borsiti",
    "Sindrome del tunnel carpale",
    "Fascite plantare",
    "Riabilitazione post-chirurgica"
  ];

  const metodologie = [
    {
      nome: "Terapia Manuale Ortopedica",
      descrizione: "Tecniche manuali per il trattamento delle disfunzioni muscolo-scheletriche"
    },
    {
      nome: "Metodo Mézières",
      descrizione: "Rieducazione posturale globale per il riequilibrio delle catene muscolari"
    },
    {
      nome: "Kinesiotaping",
      descrizione: "Applicazione di tape elastici per supporto muscolare e articolare"
    },
    {
      nome: "Dry Needling",
      descrizione: "Tecnica di puntura secca per il trattamento dei trigger point"
    }
  ];

  return (
    <div className="min-h-screen">
      <Navigation />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-primary/10 via-secondary/5 to-accent/10 section-padding">
        <div className="container-custom">
          <div className="text-center space-y-6 max-w-4xl mx-auto">
            <Badge className="bg-primary/10 text-primary border-primary/20">
              I Nostri Servizi
            </Badge>
            <h1 className="text-5xl lg:text-6xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
              Trattamenti Specializzati
            </h1>
            <p className="text-xl text-muted-foreground leading-relaxed">
              Offriamo una gamma completa di servizi di riabilitazione motoria, 
              fisioterapia e ginnastica posturale personalizzati per ogni esigenza
            </p>
          </div>
        </div>
      </section>

      {/* Servizi Dettagliati */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {serviziDettagliati.map((servizio, index) => (
              <Card key={index} className="medical-card group hover:scale-[1.02] smooth-transition">
                <div className="relative overflow-hidden rounded-t-xl">
                  <img 
                    src={servizio.image} 
                    alt={servizio.title}
                    className="w-full h-48 object-cover group-hover:scale-110 smooth-transition"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 text-white">
                    <servizio.icon className="h-8 w-8 mb-2" />
                    <Badge className="bg-white/20 text-white border-white/30">
                      {servizio.durata}
                    </Badge>
                  </div>
                  <div className="absolute bottom-4 right-4">
                    <div className="bg-white/90 px-3 py-1 rounded-full">
                      <span className="text-sm font-bold text-primary">{servizio.prezzo}</span>
                    </div>
                  </div>
                </div>
                
                <CardHeader>
                  <CardTitle className="text-xl">{servizio.title}</CardTitle>
                  <CardDescription className="text-primary font-medium">
                    {servizio.subtitle}
                  </CardDescription>
                  <p className="text-muted-foreground">{servizio.description}</p>
                </CardHeader>
                
                <CardContent>
                  <div className="space-y-3">
                    <h4 className="font-semibold text-sm uppercase tracking-wide text-primary">
                      Cosa Include:
                    </h4>
                    <ul className="space-y-2">
                      {servizio.dettagli.map((dettaglio, idx) => (
                        <li key={idx} className="flex items-start space-x-2 text-sm">
                          <CheckCircle className="h-4 w-4 text-accent mt-0.5 flex-shrink-0" />
                          <span>{dettaglio}</span>
                        </li>
                      ))}
                    </ul>
                    <Button className="w-full mt-4 medical-gradient text-white group">
                      Prenota Trattamento
                      <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 smooth-transition" />
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Patologie Trattate */}
      <section className="section-padding bg-muted/30">
        <div className="container-custom">
          <div className="text-center space-y-4 mb-12">
            <Badge className="bg-accent/10 text-accent border-accent/20">
              Patologie Trattate
            </Badge>
            <h2 className="text-4xl font-bold">Condizioni che Trattiamo</h2>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              La nostra esperienza copre un'ampia gamma di patologie e disturbi muscolo-scheletrici
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {patologie.map((patologia, index) => (
              <div key={index} className="flex items-center space-x-3 medical-card p-4 hover:bg-primary/5 smooth-transition">
                <Zap className="h-5 w-5 text-primary flex-shrink-0" />
                <span className="font-medium">{patologia}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Metodologie */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="text-center space-y-4 mb-12">
            <Badge className="bg-secondary/10 text-secondary border-secondary/20">
              Metodologie
            </Badge>
            <h2 className="text-4xl font-bold">Tecniche e Approcci</h2>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Utilizziamo le più moderne e validate tecniche di riabilitazione
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {metodologie.map((metodologia, index) => (
              <Card key={index} className="medical-card">
                <CardHeader>
                  <CardTitle className="text-lg text-primary">{metodologia.nome}</CardTitle>
                  <CardDescription>{metodologia.descrizione}</CardDescription>
                </CardHeader>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Orari e Prezzi */}
      <section className="section-padding bg-muted/30">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Orari */}
            <Card className="medical-card">
              <CardHeader>
                <CardTitle className="flex items-center space-x-2">
                  <Clock className="h-5 w-5 text-primary" />
                  <span>Orari di Apertura</span>
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="flex justify-between items-center py-2 border-b border-border/50">
                  <span className="font-medium">Lunedì - Venerdì</span>
                  <span className="text-primary font-semibold">8:00 - 19:00</span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-border/50">
                  <span className="font-medium">Sabato</span>
                  <span className="text-primary font-semibold">8:00 - 13:00</span>
                </div>
                <div className="flex justify-between items-center py-2">
                  <span className="font-medium">Domenica</span>
                  <span className="text-muted-foreground">Chiuso</span>
                </div>
                <div className="mt-6 p-4 bg-primary/5 rounded-lg">
                  <p className="text-sm text-primary font-medium">
                    💡 Disponibili anche appuntamenti serali su richiesta
                  </p>
                </div>
              </CardContent>
            </Card>

            {/* Informazioni Prezzi */}
            <Card className="medical-card">
              <CardHeader>
                <CardTitle className="flex items-center space-x-2">
                  <Target className="h-5 w-5 text-primary" />
                  <span>Informazioni Tariffe</span>
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="space-y-3">
                  <div className="flex justify-between items-center py-2 border-b border-border/50">
                    <span>Prima Visita + Trattamento</span>
                    <span className="text-primary font-semibold">€ 70</span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-border/50">
                    <span>Seduta Singola</span>
                    <span className="text-primary font-semibold">€ 45-65</span>
                  </div>
                  <div className="flex justify-between items-center py-2">
                    <span>Pacchetto 5 Sedute</span>
                    <span className="text-accent font-semibold">€ 220 (-10%)</span>
                  </div>
                </div>
                <div className="mt-6 p-4 bg-accent/5 rounded-lg">
                  <p className="text-sm text-accent font-medium">
                    ✅ Convenzioni con assicurazioni sanitarie
                  </p>
                  <p className="text-sm text-muted-foreground mt-1">
                    Verifica la tua copertura assicurativa
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding medical-gradient text-white">
        <div className="container-custom text-center space-y-8">
          <h2 className="text-4xl font-bold">Prenota la Tua Visita</h2>
          <p className="text-xl opacity-90 max-w-2xl mx-auto">
            Contattaci per una valutazione personalizzata e inizia il tuo percorso verso il benessere
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg" 
              variant="secondary" 
              className="bg-white text-primary hover:bg-white/90"
              onClick={() => window.open('https://www.sumupbookings.com/dott-papa-peppino-salvatore', '_blank')}
            >
              <Calendar className="mr-2 h-4 w-4" />
              Prenota Online
            </Button>
            <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10" asChild>
              <a href="tel:+393475391433">
                <Phone className="mr-2 h-4 w-4" />
                Chiama: +39 347 5391433
              </a>
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Servizi;